import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export function useIsCreatable() {
  const { criteria, categories }  = useSelector(state => state.accountInfo);
  const [ objectiveCreatable, setObjectiveCreatable ] = useState(false);

  useEffect(() => {
    const criterionIsAvailable = Array.isArray(criteria) && criteria.length > 0;
    const categoryIsAvailable = Array.isArray(categories) && categories.length > 0;

    setObjectiveCreatable(criterionIsAvailable && categoryIsAvailable);
  }, [ criteria, categories ]);

  return [ objectiveCreatable ];
};
